export default {
  background:
    'transparent linear-gradient(84deg, #004E27 60%, #D8B143 115%) 0% 0% no-repeat padding-box;',
};
